import { openBlock as s, createElementBlock as t, createElementVNode as o, renderSlot as r } from "vue";
import { _ as c } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/Slide.css';const d = {}, n = { class: "slide swiper-slide" }, i = { class: "slide-inner" };
function l(e, _) {
  return s(), t("div", n, [
    o("div", i, [
      r(e.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const m = /* @__PURE__ */ c(d, [["render", l], ["__scopeId", "data-v-9cee6b9a"]]);
export {
  m as default
};
